import React, { useState, useEffect, useContext } from "react";
import localization from "assets/localization/localization";
import Images from "assets/images/imageData";
import PocForm from "components/brandActivation/pocForm/pocForm";
import Layout from "components/sales/layout/layout";
import { Button } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import ModalPop from "components/sales/modal/modal";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import { toast } from "react-toastify";

const AddPoc = ({
  match,
  addPoc,
  pocById,
  getPocData,
  editPoc,
  getPocById,
  history,
  getPocListing,
  updatePocStatus = null,
  updateBaPocStatus= null,
  pocList = [],
}) => {
  const { id } = useParams();
  const { baseUrl } = useContext(BaseUrl);

  const [isFiled, setIsFiled] = useState(false);
  const pocInputs = {
    pocDetails: null,
  };
  const [isModal, setIsModal] = useState(false);
  const [pocData, setCorporateData] = useState(pocInputs);
  const [siteId, setSiteId] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [status, setStatus] = useState(1);

  useEffect(() => {
    if (id) {
      (async () => {
        await getPocById(id);
      })();
    }
  }, [id]);

  useEffect(() => {
    if (getPocListing !== null && match?.params?.siteId !== undefined)
      (async () => {
        await getPocListing(match?.params?.siteId);
      })();
  }, [getPocListing, match?.params?.siteId]);

  const handleSubmit = async () => {
    const { pocDetails } = pocData;
    console.log(pocData);
    if (pocDetails === null || pocDetails.level === undefined || pocDetails === null) {
      setIsFiled(true);
      setIsModal(false);
      return false;
    } else {
      console.log("id" + id);
      const activePocCount =
        pocList?.resultSets?.filter((poc) => poc.status_num === 1).length ?? 0;
      if (id === undefined && activePocCount >= 10) {
        toast.error("Max 10 active POCs are allowed.");
        return false;
      }

      if (handleValidation(pocDetails?.contact_no, pocDetails?.email)) {
        return false;
      }

      if (
        handleDuplicateEmailOrPhoneNo(pocDetails?.contact_no, pocDetails?.email)
      ) {
        return false;
      }

      setIsFiled(false);
      if (id) {
        if (pocDetails.name !== "") {
          setIsLoading(true);
          const res = await editPoc(pocDetails);
          setIsLoading(false);
          if (res) {
            setIsModal(true);
          }
        }
      } else {
        if (pocDetails.name !== "") {
          setIsLoading(true);
          const res = await addPoc(pocDetails);
          setIsLoading(false);
          if (res) {
            setIsModal(true);
          }
        }
      }
    }
  };

  const updateStatusPoc = async (val) => {
    // let requestData = {};
    // if (!val.check) {
    //   requestData = {
    //     poc_id: val.id,
    //     status: 2,
    //   };
    // } else {
    //   requestData = {
    //     poc_id: val.id,
    //     status: 1,
    //   };
    // }
    // setReqData(requestData);
    
    await updateBaPocStatus({poc_id:id, status:2}).then(async (response) => {
      if (response) {
            setIsLoading(true);
            const res = await getPocListing(siteId);
            setIsLoading(false);
            if (res) {
              setIsModal(true);
          }
        } else {
           
        }
    });
  };


  const updateInactiveStatus = async () => {

    await updateBaPocStatus({poc_id:id, status:1}).then(async (response) => {
      if (response) {
            setIsLoading(true);
            const res = await getPocListing(siteId);
            setIsLoading(false);
            if (res) {
              setIsModal(true);
          }
        } else {
           
        }
    });
  };

  // const handleInactive = () => {
  //   setStatus(0);

  // };

  const handleValidation = (phoneNo, emailId) => {
    let phoneRegex = /^(\+91-|\+91|0)?\d{10}$/;
    if (!phoneRegex.test(phoneNo)) {
      toast.error("Please enter correct phone number");
      return true;
    }

    let emailRegex =
      /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if (!emailRegex.test(emailId)) {
      toast.error("Please enter a correct email.");
      return true;
    }

    return false;
  };

  const handleDuplicateEmailOrPhoneNo = (no, email) => {
    let isTrue = false;
    let msg = "";
    if (pocList !== null && pocList?.resultSets !== undefined) {
      // eslint-disable-next-line array-callback-return
      pocList?.resultSets.map((val, i) => {
        if (id) {
          if (
            pocById?.contact_no !== undefined &&
            pocById?.contact_no !== parseInt(no) &&
            parseInt(val?.contact_no) === parseInt(no)
          ) {
            msg = no + " already exist.";
            isTrue = true;
          }

          if (
            pocById?.email !== undefined &&
            pocById?.email !== email &&
            val?.email === email
          ) {
            msg = email + " already exist.";
            isTrue = true;
          }
        } else {
          if (parseInt(val?.contact_no) === parseInt(no)) {
            msg = no + " already exist.";
            isTrue = true;
          }

          if (val?.email === email) {
            msg = email + " already exist.";
            isTrue = true;
          }
        }
      });
      if (isTrue) {
        toast.error(msg);
        return isTrue;
      }
    }

    return false;
  };

  const handleModalHide = () => {
    setIsModal(false);
    history.push(`${baseUrl}/brand-activation/viewPoc/${siteId}`);
  };

  // const headerBtns = () => {
  //   return (
  //     <>
  //     {id !== undefined &&
      
  //       <Button onClick={updateStatusPoc} className="btn btn-danger" style={{float:'left'}}>
  //         {localization.inactive}
  //         <img src={Images?.ArrowRight} alt="" />
  //     </Button>
    
  //     }
  //       <Button onClick={handleSubmit} className="btn btn-primary">
  //         {localization.submitDtl}
  //         <img src={Images?.ArrowRight} alt="" />
  //       </Button>
  //     </>
  //   );
  // };

  const headerBtns = () => {
    let statusCheck = match.params.status;
    return (
        <>
          {id !== undefined ? (
            <>
            
                {statusCheck == 1 && (
                 <>
                    <Button onClick={updateStatusPoc} className="btn btn-danger" style={{ float: 'left' }}>
                        {localization.inactive}
                        <img src={Images?.ArrowRight} alt="" />
                    </Button>
                    <Button onClick={handleSubmit} className="btn btn-primary">
                    {localization.submitDtl}
                    <img src={Images?.ArrowRight} alt="" />
                    </Button>
                    </>
                 
                )}
                {statusCheck == 2 && (
                    <Button onClick={updateInactiveStatus} className="btn btn-success" style={{ float: 'left' }}>
                        {localization.active}
                        <img src={Images?.ArrowRight} alt="" />
                    </Button>
                    
                )}
              
            </>
          ):<Button onClick={handleSubmit} className="btn btn-primary">
          {localization.submitDtl}
          <img src={Images?.ArrowRight} alt="" />
          </Button>}
        </>
    );
};

  const handlePocSubmit = (val) => {
    setCorporateData({ ...pocData, pocDetails: val });
  };
  useEffect(() => {
    setSiteId(match.params.siteId);
  }, [match.params.siteId]);

  return (
    <Layout
      title={id ? localization.editPoc : localization.addPoc}
      Buttons={headerBtns}
      className={isFiled ? "requiredFileds" : ""}
      isGoback
      isLoading={isLoading}
      linkUrl={`${baseUrl}/brand-activation/viewPoc/${siteId}`}
    >
      <PocForm
        pocById={pocById}
        handleValue={handlePocSubmit}
        id={id ? id : null}
        siteId={siteId}
      />

      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.pocSucces}</h5>
          <Link
            to={
              match?.params?.type !== undefined
                ? `${baseUrl}/brand-activation/viewPoc/${match?.params?.type}/${siteId}`
                : `${baseUrl}/brand-activation/viewPoc/${siteId}`
            }
            className="btn btn-primary mb-4"
          >
            {localization.pocList} <img src={Images?.ArrowRight} alt="" />
          </Link>
        </div>
      </ModalPop>
    </Layout>
  );
};

AddPoc.propTypes = {};

export default AddPoc;
